import { Component, ViewEncapsulation, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Menu, NavService } from '../../services/nav.service';
import { LayoutService } from '../../services/layout.service';
import { DataService } from '../../services/data.svc';
import { AbsAuthService, AuthApiService } from '../../services/auth.svc';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  providers:[{provide: AbsAuthService, useClass: AuthApiService}],
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {


  public iconSidebar;
  public menuItems: Menu[];

  // For Horizontal Menu
  public margin: any = 0;
  public width: any = window.innerWidth;
  public leftArrowNone: boolean = true;
  public rightArrowNone: boolean = false;
  private role: any;
  public hideAnalytics:  string = 'false';
  public hideMonthlyOverview: string = 'false';

  constructor(private router: Router, public navServices: NavService,
    private svcData: DataService, private svcAuth: AbsAuthService,
    public layout: LayoutService) {

    this.role = JSON.parse(localStorage.getItem("currentUser")).role;
    var _analytic = localStorage.getItem("hideanalytics");
    // console.log(_analytic);
    if(typeof _analytic !== undefined && _analytic != null){
      this.hideAnalytics = _analytic;
    }

    var _ovw = localStorage.getItem("hidemonthlyoverview");
    if(typeof _ovw !== undefined && _ovw != null){
      this.hideMonthlyOverview = _ovw;
    }

    this.navServices.items.subscribe(menuItems => {
      this.menuItems = menuItems;
      // console.log(this.hideAnalytics);

      if(this.role == 'GEEK' || this.role == 'SA'){ // dataviewer , report , settings , users, analytic
        menuItems[2].status = true; // Users
        // console.log(this.hideAnalytics);
        this.hideAnalytics == 'false' ? menuItems[3].status = true : menuItems[3].status = false; // Analytic
        menuItems[4].status = true; // Report
        menuItems[5].status = true; // Settings
        menuItems[6].status = true; // DataViewer
        this.hideMonthlyOverview == 'false' ? menuItems[7].status = true : menuItems[7].status = false; // Calendar
      }
      else if(this.role == 'ADMIN'){
        menuItems[2].status = true;  // users
        this.hideAnalytics == 'false'?menuItems[3].status = true:menuItems[3].status = false; // Analytic
        menuItems[4].status = true; // report
        this.hideMonthlyOverview == 'false' ? menuItems[7].status = true : menuItems[7].status = false; // Calendar
      }

      this.menuItems = menuItems.filter(itm => itm.status == true);

      //console.log(this.menuItems);

      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          if (event.url === '/dashboard/daily' || event.url === '/dashboard/weekly' || event.url === '/dashboard/monthly'|| event.url === '/dashboard/quarterlyfootfall') {
            this.setNavActive('Analytics');
          }
          menuItems.filter(items => {
            if (items.path === event.url) {
              this.setNavActive(items);
            }            
            if (!items.children) { return false; }
            items.children.filter(subItems => {
              if (subItems.path === event.url) {
                this.setNavActive(subItems);
              }
              if (!subItems.children) { return false; }
              subItems.children.filter(subSubItems => {
                if (subSubItems.path === event.url) {
                  this.setNavActive(subSubItems);
                }
              });
            });
          });
        }
      });
    });

  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.width = event.target.innerWidth - 500;
  }  

  sidebarToggle() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  // Active Nave state
  setNavActive(item) {
    //console.log(item)
      if(item === 'Analytics'){
        this.menuItems.filter(menuItem => {
          if (menuItem.title !== item) {
            menuItem.active = false;
          }
          if (menuItem.title === item) {
            menuItem.active = true;
          }
        });
      }
      else{

      //}
      this.menuItems.filter(menuItem => {
        //console.log(menuItem);
        if (menuItem !== item) {
          menuItem.active = false;
        }
        if (menuItem === item) {
          menuItem.active = true;
        }
        if (menuItem.children && menuItem.children.includes(item)) {
          menuItem.active = true;
        }
        if (menuItem.children) {
          menuItem.children.filter(submenuItems => {
            if (submenuItems.children && submenuItems.children.includes(item)) {
              menuItem.active = true;
              submenuItems.active = true;
            }
          });
        }
      });
    }
  }

  // Click Toggle menu
  toggletNavActive(item) {
    if(item.path == '/logout'){
      this.logout();
    }
    if (!item.active) {
      this.menuItems.forEach(a => {
        if (this.menuItems.includes(item)) {
          a.active = false;
        }
        if (!a.children) { return false; }
        a.children.forEach(b => {
          if (a.children.includes(item)) {
            b.active = false;
          }
        });
      });
    }
    item.active = !item.active;
  }

  logout = function() {
    var _usr = '';
    if(this.svcAuth.getCurrentUser() != null){
      var user = this.svcAuth.getCurrentUser();
      user.status = 0;
      _usr = user.userId;
      //this.svcData.deleteToken(localStorage.getItem('fcmToken').toString(), _usr.toString()).subscribe();
      this.svcData.sessionUpdate(user).subscribe();
    }
    
    this.svcAuth.logout();
    
    this.isAuthOk = false;
    this.router.navigate(['/login']);
  }


  // For Horizontal Menu
  scrollToLeft() {
    if (this.margin >= -this.width) {
      this.margin = 0;
      this.leftArrowNone = true;
      this.rightArrowNone = false;
    } else {
      this.margin += this.width;
      this.rightArrowNone = false;
    }
  }

  scrollToRight() {
    if (this.margin <= -3051) {
      this.margin = -3464;
      this.leftArrowNone = false;
      this.rightArrowNone = true;
    } else {
      this.margin += -this.width;
      this.leftArrowNone = false;
    }
  }
}
